var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _Factory_json, _Factory_string, _Factory_arrayBuffer;
import { ArrayBuffer as SocketArrayBuffer } from "./ArrayBuffer";
import { Json as SocketJson } from "./Json";
import { String as SocketString } from "./String";
export class Factory {
    get json() {
        if (!__classPrivateFieldGet(this, _Factory_json, "f"))
            __classPrivateFieldSet(this, _Factory_json, new SocketJson(this.backend, this.isOpen), "f");
        return __classPrivateFieldGet(this, _Factory_json, "f");
    }
    get string() {
        if (!__classPrivateFieldGet(this, _Factory_string, "f"))
            __classPrivateFieldSet(this, _Factory_string, new SocketString(this.backend, this.isOpen), "f");
        return __classPrivateFieldGet(this, _Factory_string, "f");
    }
    get arrayBuffer() {
        if (!__classPrivateFieldGet(this, _Factory_arrayBuffer, "f"))
            __classPrivateFieldSet(this, _Factory_arrayBuffer, new SocketArrayBuffer(this.backend, this.isOpen), "f");
        return __classPrivateFieldGet(this, _Factory_arrayBuffer, "f");
    }
    constructor(backend, isOpen) {
        this.backend = backend;
        this.isOpen = isOpen;
        _Factory_json.set(this, void 0);
        _Factory_string.set(this, void 0);
        _Factory_arrayBuffer.set(this, void 0);
    }
    createResponse(header = {}) {
        return { status: 101, socket: this, header };
    }
    close(code, reason) {
        this.backend.close(code, reason);
    }
}
_Factory_json = new WeakMap(), _Factory_string = new WeakMap(), _Factory_arrayBuffer = new WeakMap();
//# sourceMappingURL=Factory.js.map